import { addEmailRecipient } from "../../../../../actions/Utilities/EmailRecipient";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
const useAddEmailRecipient = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (newEmailRecipient) => addEmailRecipient(newEmailRecipient),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["GetEmailRecipient"]);
        queryClient.invalidateQueries(["EmailPermission"]);
        queryClient.invalidateQueries("GetFieldsOwned");
        queryClient.invalidateQueries("GetOperationGroupMapping");

        toast.fire("Success", "Email Recipient Added Successfully", "success");
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add EmailRecipient", "error");
      },
    }
  );

  return mutate;
};
export default useAddEmailRecipient;
